import * as yup from "yup";

import {
  ChangePassword,
  ChangePasswordVariables,
} from "_graphql/mutation/__generated__/ChangePassword";
import { Modal, OfficeButton } from "components";

import { CHANGE_PASSWORD } from "_graphql/visal/mutations/auth";
import { PasswordForm } from "components/forms";
import toast from "react-hot-toast";
import { useCurrentUser } from "_graphql/cache/auth";
import { useFormik } from "formik";
import { useMutation } from "@apollo/client";
import { wrapClick } from "utils";

const schema = yup.object().shape({
  password: yup.string().required("Password is required"),
  confirmPassword: yup
    .string()
    .required("Confirm password is required")
    .oneOf([yup.ref("password")], "Passwords must match"),
});

type Props = {
  open: boolean;
  setOpen: (val: boolean) => void;
};

const UpdatePasswordContainer = ({ open, setOpen }: Props) => {
  const currentUser = useCurrentUser();
  const [updatePassword, { loading }] = useMutation<
    ChangePassword,
    ChangePasswordVariables
  >(CHANGE_PASSWORD);
  const form = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: schema,
    onSubmit: (values, helpers) => {
      updatePassword({
        variables: {
          id: currentUser?.user_id || "",
          password: values.password,
        },
      })
        .then(() => {
          setOpen(false);
          toast.success("Password updated successfully");
          helpers.resetForm();
        })
        .catch((error) => {
          toast.error(error.message);
          helpers.setFieldError("password", error.message);
        });
    },
  });
  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title="Update Password"
      description="Update your password"
      renderActions={() => (
        <OfficeButton
          size="sm"
          onClick={wrapClick(form.handleSubmit)}
          loading={loading}
          disabled={loading}
        >
          Update Password
        </OfficeButton>
      )}
    >
      <PasswordForm form={form} />
    </Modal>
  );
};

export default UpdatePasswordContainer;
